import styled from 'styled-components';

export const WrapperInputs = styled.div`
	display: flex;
	gap: 35px;
`;

export const Label = styled.label`
	font-weight: 500;
	font-size: 14px;
	color: #495057;
	margin-bottom: 4px;
	display: block;
`;

export const ToggleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
	margin-bottom: 25px;
`;

export const WidgetUrlContainer = styled.div`
	margin-top: 15px;
	margin-bottom: 25px;
	padding: 15px;
	background-color: #f8f9fa;
	border: 1px solid #e9ecef;
	border-radius: 8px;
`;

export const WidgetUrlLabel = styled.label`
	font-weight: 600;
	font-size: 14px;
	color: #495057;
	margin-bottom: 8px;
	display: block;
`;

export const WidgetUrlWrapper = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	flex-wrap: wrap;
`;

export const WidgetUrl = styled.code`
	flex: 1;
	padding: 8px 12px;
	background-color: #ffffff;
	border: 1px solid #ced4da;
	border-radius: 4px;
	font-family: 'Monaco', 'Consolas', 'Courier New', monospace;
	font-size: 12px;
	color: #495057;
	word-break: break-all;
	min-width: 200px;
`;

export const ImageSection = styled.div`
	margin: 20px 0;
	padding: 20px;
	border: 1px solid #e9ecef;
	border-radius: 8px;
	background-color: #f8f9fa;
`;

export const ImageContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 15px;
`;

export const ImageOptions = styled.div`
	display: flex;
	gap: 10px;
`;

export const UploadContainer = styled.div`
	display: flex;
	justify-content: center;
	padding: 20px;
`;

export const DangerZone = styled.div`
	margin-top: 40px;
	padding: 20px;
	border: 1px solid #dc3545;
	border-radius: 8px;
	background-color: #fff5f5;
`;

export const DangerZoneTitle = styled.h3`
	color: #dc3545;
	font-size: 18px;
	font-weight: 600;
	margin: 0 0 15px 0;
`;

export const DangerZoneContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;

	@media (max-width: 768px) {
		flex-direction: column;
	}
`;

export const DangerZoneText = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	color: #495057;
	font-size: 14px;
	line-height: 1.5;
`;

export const WarningText = styled.div<{ hidden?: boolean }>`
	padding: 10px;
	background-color: #fff3cd;
	border: 1px solid #ffc107;
	border-radius: 4px;
	color: #856404;
	font-size: 13px;
`;

export const DangerZoneButtons = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
`;
